module.exports = __webpack_public_path__ + "static/img/bim1.0309f61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shouye/bim1.png
// module id = ozKm
// module chunks = 17